
import React from 'react';
import './Sprayermakings.css';
import sprayerImg from '../../../imgs/Sprayermaking.webp';

const Sprayermakings = () => {
    return (
        <div className="sprayer-container">
            <div className="sprayer-img">
                <img src={sprayerImg} alt="Backpack Sprayer" />
            </div>

            <div className="sprayer-text">
                <h4>There are 2 common backpack sprayers production methods(Injection Molding & Extrusion Blow Molding) on the market.And we recommend using extrusion blow molding that is because:</h4>
               
                <ol>
                    <li>The weight of the sprayer can be adjusted from 800g to 1500g to meet different customer needs.</li>
                    <li>Seamless design reduces leakage risk.</li>
                </ol>
            </div>
        </div>
    );
};

export default Sprayermakings;
